import { IMainTheme } from '../../types/theme';
import breakpoints from '../breakpoints';
import globalColors from '../colors';
import colors from './colors';

const storeTheme: IMainTheme = {
  name: 'store',
  colors: {
    ...globalColors,
    ...colors,
  },
  breakpoints: {
    ...breakpoints,
  },
  fonts: {
    primary: {
      regular: '"Ubisoft Sans Regular", Arial, sans-serif',
      bold: '"Ubisoft Sans Bold", Arial, sans-serif',
    },
    secondary: {
      regular: '"TT Commons Regular", "Ubisoft Sans Regular", Arial, sans-serif',
      bold: '"TT Commons Bold", "Ubisoft Sans Regular", Arial, sans-serif',
      light: '"TT Commons Ligh", "Ubisoft Sans Regular", Arial, sans-serif',
    },
  },
};

export default storeTheme;
